import { useNavigate } from "react-router-dom";
import "./MHW.css";

const MHWPage = () => {
  const navigate = useNavigate();

  return (
    <div className="mhw-container"> {/* 🔙 Back Button */}
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Go Back
      </button>
      <h2>Mental Health & Well-being</h2>

      <div className="btn-group">
        <button onClick={() => navigate("/awards")} className="mhw-btn">
          Awards
        </button>

        <button onClick={() => navigate("/blog")} className="mhw-btn outline">
          Blog
        </button>
      </div>
    </div>
  );
};

export default MHWPage;